export const giftCardsRoutes = [
  {
    path: "/gift-cards",
    name: "GiftCards",
    component: () => import("@/views/GiftCards/GiftCards.vue"),
    // meta: { topLevel: true },
  },
  {
    path: "/gift-cards/my-purchases",
    name: "MyPurchases",
    component: () => import("@/views/GiftCards/MyPurchases.vue"),
  },
  {
    path: "/gift-cards/order/:id",
    name: "Order",
    component: () => import("@/views/GiftCards/Order.vue"),
  },
  {
    path: "/gift-cards/checkout/:id",
    name: "Checkout",
    component: () => import("@/views/GiftCards/Checkout.vue"),
  },
  {
    path: "/gift-cards/confirmation/:id",
    name: "Confirmation",
    component: () => import("@/views/GiftCards/Confirmation.vue"),
  },
  {
    path: "/gift-cards/success/:id",
    name: "SuccessPage",
    component: () => import("@/views/GiftCards/SuccessPage.vue"),
  },
  {
    path: "/gift-cards/error",
    name: "ErrorPage",
    component: () => import("@/views/GiftCards/ErrorPage.vue"),
  },
];
